import React, { FC } from 'react';
import moment, { Moment } from 'moment';
import { RoomRateAvailability } from 'shared-types/Room';
import { JourneyParams } from 'shared-types/Common';
import { DateRangeInput } from '@common/components/DateRangeInput';
import { ClassFiltersColumn } from '../Filters.styles';

export type DatesPickerProps = {
  showDatesPicker?: boolean;
  onDateChange: (props) => void;
  fromDate?: Moment | string;
  toDate?: Moment | string;
  isSingle?: boolean;
  availability?: RoomRateAvailability;
  propertyId: number;
  journeyParams: JourneyParams;
  rateCode?: string;
  roomCode?: string;
  isHomepage?: boolean;
  fetchAvailability: (
    propertyId: number,
    journeyParams: JourneyParams,
    extendedDate: Moment
  ) => void;
};

export const DatesPicker: FC<DatesPickerProps> = ({
  showDatesPicker = true,
  onDateChange,
  fromDate,
  toDate = moment(),
  isSingle = false,
  availability,
  journeyParams,
  propertyId,
  fetchAvailability,
  rateCode,
  roomCode,
  isHomepage,
}) =>
  showDatesPicker ? (
    <ClassFiltersColumn>
      <DateRangeInput
        onChange={onDateChange}
        startDate={fromDate as Moment}
        endDate={toDate as Moment}
        isSingle={isSingle}
        availability={availability}
        journeyParams={journeyParams}
        propertyId={propertyId}
        fetchAvailability={fetchAvailability}
        rateCode={rateCode}
        roomCode={roomCode}
        isHomepage={isHomepage}
      />
    </ClassFiltersColumn>
  ) : null;
